import { render, staticRenderFns } from "./interNews.vue?vue&type=template&id=6983cb30&scoped=true"
import script from "./interNews.vue?vue&type=script&lang=js"
export * from "./interNews.vue?vue&type=script&lang=js"
import style0 from "./interNews.vue?vue&type=style&index=0&id=6983cb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6983cb30",
  null
  
)

export default component.exports